// extracted by mini-css-extract-plugin
export default {"cls1":"UserListMenu-cls1__e7b3f93846db648e7038","cls2":"UserListMenu-cls2__d46f1c9af3dcb274a728 UserListMenu-cls1__e7b3f93846db648e7038"};